import { TextField } from '@mui/material'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'

/**
 * Renders a password input field with error handling and helper text.
 *
 * @author Maria Eduarda Franke
 * @param {string} props.name - The name of the input field.
 * @param {string} props.label - The label for the input field.
 * @param {Object} props.control - The control object from react-hook-form.
 * @param {Object} props.errors - The errors object from react-hook-form.
 * @returns {JSX.Element} The rendered component.
 */
const FormInputPassword = ({ name, label, control, errors, ...props }) => {

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <TextField
                    {...field}
                    type='password'
                    label={label}
                    placeholder={label}
                    error={!!errors}
                    helperText={errors?.message}
                    InputLabelProps={{ shrink: true }}
                    {...props}
                />
            )}
        />
    )
}

FormInputPassword.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    control: PropTypes.object,
    errors: PropTypes.object
}

export default FormInputPassword